import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Menu, MenuItem, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

const menuStyle = {
  background: '#c33764',
  color: '#fff',
  borderRadius: 1.5,
  boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
  minWidth: 220,
};

const itemStyle = {
  '&:hover': {
    backgroundColor: '#fca138',
    color: '#fff',
  },
  fontWeight: 500,
  px: 2,
  py: 1,
};

const MenuEstudante: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [submenuAnchor, setSubmenuAnchor] = useState<null | HTMLElement>(null);
  const [submenuBibAnchor, setSubmenuBibAnchor] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const openSub = Boolean(submenuAnchor);
  const openBib = Boolean(submenuBibAnchor);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseAll = () => {
    setAnchorEl(null);
    setSubmenuAnchor(null);
    setSubmenuBibAnchor(null);
  };

  return (
    <>
      <Button
        onClick={handleClick}
        endIcon={<ExpandMoreIcon />}
        sx={{ color: '#fff', textTransform: 'none', fontWeight: 500, fontSize: '16px' }}
      >
        Área do Aluno
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseAll}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ sx: menuStyle }}
      >
        <MenuItem onClick={(e) => setSubmenuAnchor(e.currentTarget)} sx={itemStyle}>
          <Box display="flex" justifyContent="space-between" width="100%">
            Secretaria <ArrowRightIcon fontSize="small" />
          </Box>
        </MenuItem>

        <MenuItem onClick={(e) => setSubmenuBibAnchor(e.currentTarget)} sx={itemStyle}>
          <Box display="flex" justifyContent="space-between" width="100%">
            Biblioteca <ArrowRightIcon fontSize="small" />
          </Box>
        </MenuItem>

        <MenuItem component={Link} to="/nucleo-apoio" onClick={handleCloseAll} sx={itemStyle}>
          Núcleo de Apoio
        </MenuItem>
      </Menu>

      <Menu
        anchorEl={submenuAnchor}
        open={openSub}
        onClose={() => setSubmenuAnchor(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ sx: menuStyle }}
      >
        <MenuItem component={Link} to="/secretaria/secad" onClick={handleCloseAll} sx={itemStyle}>
          Secretaria Acadêmica
        </MenuItem>
        <MenuItem component={Link} to="/secretaria/servicos-aluno" onClick={handleCloseAll} sx={itemStyle}>
          Serviços ao Aluno
        </MenuItem>
      </Menu>

      <Menu
        anchorEl={submenuBibAnchor}
        open={openBib}
        onClose={() => setSubmenuBibAnchor(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ sx: menuStyle }}
      >
        <MenuItem component={Link} to="/biblioteca/ambiente" onClick={handleCloseAll} sx={itemStyle}>
          Biblioteca Física
        </MenuItem>
        <MenuItem component={Link} to="https://cachola.senac.br/?locale=pt" onClick={handleCloseAll} sx={itemStyle}>
          Cachola
        </MenuItem>
      </Menu>
    </>
  );
};

export default MenuEstudante;
